import type { LongDateFormatKey } from 'moment-timezone';
import moment from 'moment-timezone';

const localizedTokens = [
  'LTS',
  'LT',
  'L',
  'LL',
  'LLL',
  'LLLL',
  'lts',
  'lt',
  'l',
  'll',
  'lll',
  'llll',
] as readonly LongDateFormatKey[];

const localizedTokenSet: ReadonlySet<LongDateFormatKey> = new Set(localizedTokens);

const isLocalizedToken = (token: string): token is LongDateFormatKey => {
  return localizedTokenSet.has(token as LongDateFormatKey);
};

export const expandLocalizedTokens = (formatString: string, locale: string = moment.locale()) => {
  const localeData = moment.localeData(locale);

  return formatString
    .split(/(\s+)/)
    .map((token) => (isLocalizedToken(token) ? localeData.longDateFormat(token) : token))
    .join('');
};

const timeTokens = /\b(HH?|hh?|mm?|ss?|a|A)\b/;
export const formatHasTimeElements = (dateFormat: string) => timeTokens.test(dateFormat);

const twentyFourHourTimeTokens = /\b(HH?)\b/;
export const formatUses24HourTime = (dateFormat: string) => twentyFourHourTimeTokens.test(dateFormat);
